var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: [_vm.$.context_body_multiselect] }, [
    _vm.items.length > 15
      ? _c(
          "div",
          { class: [_vm.$.context_body_search, "multiselect_context"] },
          [
            _c(
              "div",
              { class: [_vm.$.context_body_search_input] },
              [
                _c("vgp-input", {
                  class: "search-input",
                  style: { outline: "#fff" },
                  attrs: {
                    type: "text",
                    placeholder: _vm.locale("search_projects_placeholder"),
                    "icons-left": [{ name: "search" }],
                    small: true,
                    "select-by-focus": false,
                  },
                  model: {
                    value: _vm.searchStr,
                    callback: function ($$v) {
                      _vm.searchStr = $$v
                    },
                    expression: "searchStr",
                  },
                }),
              ],
              1
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        class: [_vm.$.multiselect_items, "gantt_scroll", "multiselect_context"],
      },
      _vm._l(_vm.visibleItems, function (item) {
        return _c(
          "div",
          {
            class: [
              _vm.$.menu_item,
              item.selected && !(item.isMultiselect && item.value !== "empty")
                ? _vm.$.selected
                : "",
              item.selected ? "selected_menu_item" : "",
              item.disabled ? _vm.$.disabled : "",
              item.divider ? _vm.$.divider : "",
            ],
            attrs: { "data-menu-type": item.type + ":" + item.menu },
            on: {
              click: function ($event) {
                return _vm.selectItem(item)
              },
            },
          },
          [
            _c("div", { class: _vm.$.item_content }, [
              item.value !== "empty"
                ? _c(
                    "div",
                    {
                      class: [
                        _vm.$.checkbox,
                        item.selected ? _vm.$.selected : "",
                      ],
                    },
                    [
                      _c("svg-sprite", {
                        style: { color: "#FFFFFF" },
                        attrs: { name: "check", type: "regular", size: 16 },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              item.icon
                ? _c(
                    "div",
                    {
                      class: _vm.$.icon,
                      style: {
                        background: item.isColorField ? item.name : "",
                      },
                    },
                    [
                      item.iconType === "img"
                        ? _c("img", { attrs: { src: item.icon } })
                        : _c("svg-sprite", {
                            style: {
                              color:
                                item.iconSelectedColor && item.selected
                                  ? item.iconSelectedColor
                                  : item.iconColor,
                            },
                            attrs: {
                              name: item.icon,
                              type: item.iconType,
                              size: item.iconSize,
                            },
                          }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !item.isColorField
                ? _c(
                    "div",
                    {
                      class: [
                        _vm.$.label,
                        item.labelBg ? _vm.$.is_label_field : "",
                      ],
                      style: {
                        color: item.labelColor || "",
                        background: item.labelBg || "",
                      },
                    },
                    [_vm._v("\n          " + _vm._s(item.name) + "\n        ")]
                  )
                : _vm._e(),
            ]),
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _vm.multiselectChanges
      ? _c(
          "div",
          { class: _vm.$.multiselect_submit },
          [
            _c("vgp-button", {
              class: _vm.$.multiselect_submit_button,
              attrs: {
                type: "primary",
                small: "",
                label: _vm.locale("common_ok"),
              },
              on: { onClick: _vm.submitMultiselect },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }